import {UploadMediaContainer} from './upload-media-container';

export class OperationUploadContainer {
  uploadMediaContainers: Array<UploadMediaContainer>;
}
